/**
 * this service is private and meant to be used by ParamTypeMixin only!
 */
import isString from 'lodash/isString';
import isNumber from 'lodash/isNumber';

// helper methods of service

// methods exported by service
/**
 * used to add the default fieldRules
 */
const addParamFieldRules = function () {
	if (this.isRequired) {
		const requiredRule = (val) => (val || '').length > 0 || 'This field is required';
		this.addFieldRule(requiredRule);
	}
};

/**
 * apply label of param from options
 */
const applyLabelFromOptions = function (items) {
	if (this.localValue && !this.localValueDisplay) {
		// in case localValueDisplay is missing, and we have items, we try to set localValueDisplay from items
		const newValueDisplay = items.find(({ value }) => {
			if (!isNaN(this.localValue) && isNumber(value)) {
				return this.localValue == value;
			}
			if (isString(this.localValue)) {
				return value === decodeURIComponent(this.localValue);
			}
			return value === this.localValue;
		})?.option;
		if (newValueDisplay) {
			// IMPORTANT! THIS IS ONLY UPDATING THE LABEL, NOT THE VALUE ITSELF, WE'RE NOT SUPPOSE TO CHANGE THE VALUE FROM HERE WITHOUT ANY USER INTERACTION
			this.localValueDisplay = newValueDisplay;
		}
	}
};

const ParamTypeMixinService = {
	addParamFieldRules,
	applyLabelFromOptions,
};

export default ParamTypeMixinService;
